import UserHome from "views/ResponseView";

export default function Page() {
  return (
    <>
      <UserHome />
    </>
  );
}
